export default theme => {
  return `
  .mu-refresh-control{
    color: ${theme.primary};
  }
  `;
};



// WEBPACK FOOTER //
// ./src/muse-ui/LoadMore/theme.js